import React, { useState, useEffect } from "react";
import { Button, DatePicker, Input,Pagination } from "antd"; // Ant Design components
import { EditOutlined, DeleteOutlined, TaobaoSquareFilled } from "@ant-design/icons"; // Ant Design icons

import isBetween from "dayjs/plugin/isBetween"; // Import the isBetween plugin
import dayjs from "dayjs";
import { FaDownload, FaUpload } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { apiService } from "../services/apiService";
import Spinner from "./spinner";
import * as XLSX from "xlsx"; // Import xlsx library
import { toast } from "react-toastify";
const { RangePicker } = DatePicker; // RangePicker to select date range
 
dayjs.extend(isBetween);

// Sample Dynamic Column Data (could come from API)
const dynamicColumns = [
    { title: "Customer", dataIndex: "customer_name" },
    { title: "Criteria", dataIndex: "criteria" },
    { title: "Model", dataIndex: "model" },
    // { title: "Item Type", dataIndex: "item_type" },
    // { title: "Customer", dataIndex: "customer_name" },
    // { title: "Category Code", dataIndex: "category_code" },
//     { title: "Part Number", dataIndex: "part_number" ,  style: { maxWidth: 200, whiteSpace: "normal", wordBreak: "break-word" }
// },
    // { title: "Order Number", dataIndex: "order_number" },
    // { title: "Invoice Number", dataIndex: "invoice_number" },
    // { title: "Invoice Date", dataIndex: "invoice_date" },
    { title: "Invoice Month", dataIndex: "invoice_month_year" },

    { title: "Unit Selling Price", dataIndex: "unit_selling_price" },
    { title: "Quantity", dataIndex: "total_quantity" },
    // { title: "Gst Amount", dataIndex: "gst_amount" },
    { title: "Invoice Amount", dataIndex: "total_invoice_amount" },
    // { title: "Cust Po Number", dataIndex: "cust_po_number" },
];

const getSummaryRecords = (response) => {
    return (
        response?.data?.records ||
        response?.data?.data?.records ||
        response?.records ||
        response?.data ||
        []
    );
};

const getSummaryPagination = (response) => {
    return response?.data?.pagination || response?.data?.data?.pagination || response?.pagination || {};
};

const getNestedRows = (record) => {
    if (!record || typeof record !== "object") return null;

    return (
        (Array.isArray(record.types) ? record.types : null) ||
        record.records ||
        record.rows ||
        record.items ||
        (Array.isArray(record.criteria) ? record.criteria : null) ||
        record.details ||
        record.children ||
        null
    );
};

const normalizeSummaryRecords = (records) => {
    const source = Array.isArray(records)
        ? records
        : Array.isArray(records?.customers)
            ? records.customers
            : Array.isArray(records?.data)
                ? records.data
                : records && typeof records === "object"
                    ? Object.values(records)
                    : [];

    const flattened = source.flatMap((record, customerIndex) => {
        const nestedRows = getNestedRows(record);
        const rows = Array.isArray(nestedRows) ? nestedRows : [record];

        return rows.map((row, rowIndex) => ({
            ...row,
            id:
                row.id ||
                row.summary_id ||
                `${record.customer_id || record.customer_name || "customer"}-${customerIndex}-${rowIndex}`,
            customer_name:
                row.customer_name ||
                row.customer ||
                row.customerGroup ||
                record.customer_name ||
                record.customer ||
                record.customerGroup ||
                "",
            criteria:
                (typeof row.criteria === "string" ? row.criteria : "") ||
                row.criterion ||
                row.record_criteria ||
                row.item_type_name ||
                row.options ||
                (typeof record.criteria === "string" ? record.criteria : "") ||
                record.criterion ||
                "",
            item_type:
                row.item_type_name ||
                row.item_type ||
                row.options ||
                "",
            invoice_month_year:
                row.invoice_month_year ||
                row.month_year ||
                row.monthYear ||
                row.period ||
                "",
            total_quantity:
                row.total_quantity ??
                row.total_quantity_invoiced ??
                row.quantity ??
                row.qty ??
                0,
            total_invoice_amount:
                row.total_invoice_amount ??
                row.invoice_amount ??
                row.amt ??
                0,
            unit_selling_price:
                row.unit_selling_price ??
                row.avg_unit_selling_price ??
                row.unit_price ??
                "",
        }));
    });

    const customerOrder = [];
    const customerGroups = flattened.reduce((acc, row) => {
        const customer = row.customer_name || "Unknown";
        if (!acc[customer]) {
            acc[customer] = [];
            customerOrder.push(customer);
        }
        acc[customer].push(row);
        return acc;
    }, {});
    const groupedRows = customerOrder.flatMap((customer) => customerGroups[customer]);

    const customerCounts = groupedRows.reduce((acc, row) => {
        const customer = row.customer_name || "Unknown";
        acc[customer] = (acc[customer] || 0) + 1;
        return acc;
    }, {});

    const criteriaCounts = groupedRows.reduce((acc, row) => {
        const customer = row.customer_name || "Unknown";
        const criteria = row.criteria || "Unknown";
        const key = `${customer}__${criteria}`;
        acc[key] = (acc[key] || 0) + 1;
        return acc;
    }, {});

    const seenCustomers = {};
    const seenCriteria = {};
    return groupedRows.map((row) => {
        const customer = row.customer_name || "Unknown";
        const criteria = row.criteria || "Unknown";
        const criteriaKey = `${customer}__${criteria}`;
        seenCustomers[customer] = (seenCustomers[customer] || 0) + 1;
        seenCriteria[criteriaKey] = (seenCriteria[criteriaKey] || 0) + 1;

        return {
            ...row,
            customerRowSpan: seenCustomers[customer] === 1 ? customerCounts[customer] : 0,
            criteriaRowSpan: seenCriteria[criteriaKey] === 1 ? criteriaCounts[criteriaKey] : 0,
        };
    });
};



const ActualSalesSummary = () => {
    const [filteredData, setFilteredData] = useState([]); // Store filtered data
    const [editingKey, setEditingKey] = useState(null); // Store the key of the row being edited
    const [dates, setDates] = useState([null, null]);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]); // Store the actual sales data
    const [total, setTotal] = useState(0); // Store total number of records for pagination
    const [currentPage, setCurrentPage] = useState(1); // Store current page for pagination     
    const [pageSize, setPageSize] = useState(10); // Store page size for pagination
    const navigate = useNavigate();
    //  const [loading, setLoading] = useState(false); // Track loading state
    // Fetch sales data on component mount
    const fetchSalesData = async (page,limit,startDate=null,endDate=null) => {
        setLoading(true); // Start loading
        try {
            const payload = {
                page,
                limit,
            };
            payload.record_type = 'actual_sales_summary';
            // Add date range to the payload if provided
            if (startDate && endDate) {
                payload.startDate = startDate;
                payload.endDate = endDate;
            }
           
            const response = await apiService(`actual-sales/get-summary-records`, "POST",payload); // Replace with your API endpoint
            console.log("Fetched sales data:", response);
            const records = normalizeSummaryRecords(getSummaryRecords(response));
            console.log("Normalized sales summary rows:", records);
            setData(records); // Set the fetched data
            setFilteredData(records); // Initialize filtered data
            setTotal(getSummaryPagination(response).total || records.length); // Set total number of records for pagination
     
        } catch (error) {
            console.error("Error fetching sales data:", error);

        } finally {
            setLoading(false); // Stop loading
        }
    };

    useEffect(() => {

      
        fetchSalesData(currentPage, pageSize); // Fetch sales data on component mount
    }, []); // Empty dependency array ensures this runs only once on mount
  // Handle page change
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    // Preserve date range when paginating
    if (dates && dates.length === 2 && dates[0] && dates[1]) {
        const [startDate, endDate] = dates.map((date) => date.format("YYYY-MM-DD"));
        fetchSalesData(page, pageSize, startDate, endDate);
    } else {
        fetchSalesData(page, pageSize);
    }
};

const handleDateRangeChange = (dates) => {
    setDates(dates);

    
};
const handleSearch = () => {
    if (dates && dates.length === 2) {
        const [startDate, endDate] = dates.map((date) => date.format("YYYY-MM-DD")); // Format dates
        fetchSalesData(currentPage, pageSize, startDate, endDate); // Fetch data with date range
    } else {
        fetchSalesData(currentPage, pageSize); // Fetch data without date range
    }
};
    // Editable Cell component for editable cells in the table
    const EditableCellOld = ({ record, columnKey, ...restProps }) => {
        return (
            <td {...restProps}>
                {record.id === editingKey ? (
                    <Input
                        value={record[columnKey]}
                        onChange={(e) => {
                            const newData = [...filteredData];
                            const index = newData.findIndex((item) => item.id === record.id);
                            if (index > -1) {
                                newData[index][columnKey] = e.target.value;
                                setFilteredData(newData);
                            }
                        }}
                    />
                ) : (
                    <div>{record[columnKey]}</div>
                )}
            </td>
        );
    };
    const EditableCell = ({ record, columnKey }) => {
        console.log("Rendering cell for record:", record, "columnKey:", columnKey);
        const [error, setError] = useState(null);

        // Make 'model' and 'item_type' non-editable
        const isNonEditable = columnKey === "model" || columnKey === "item_type";

        const handleChange = (e) => {
            let newValue = e.target.value;

            // Validation for price fields
            if (
                columnKey === "unit_selling_price" ||
                columnKey === "invoice_amount"
            ) {
                if (isNaN(newValue) || newValue <= 0) {
                    setError('Please enter a valid price greater than 0');
                } else {
                    setError(null);
                }
            }

            // Update the value in filteredData directly
            const newData = [...filteredData];
            const index = newData.findIndex((item) => item.id === record.id);
            if (index > -1) {
                newData[index][columnKey] = newValue;
                setFilteredData(newData);
            }
        };

        if (record.id === editingKey) {
            if (isNonEditable) {
                return <div>{record[columnKey]}</div>;
            }
            return (
                <>
                    <Input
                        value={record[columnKey]}
                        onChange={handleChange}
                        style={{ borderColor: error ? 'red' : '' }}
                    />
                    {error && <div style={{ color: 'red', fontSize: '12px' }}>{error}</div>}
                </>
            );
        }
        return <div>{record[columnKey]}</div>;
    };
    
      
      
      
    const startEditing = (key) => {
        setEditingKey(key); // Set the key for the row being edited
    };

    const cancelEditing = () => {
        setEditingKey(null); // Cancel editing by clearing the editing key
    };

    const deleteRow = (key) => {
        const newData = filteredData.filter((item) => item.id !== key);
        setFilteredData(newData); // Remove the row from the filtered data
    };

    const saveRow = async (key) => {
        const newData = [...filteredData];
        const index = newData.findIndex((item) => key === item.id);
      
        if (index > -1) {
          const row = newData[index];
          
          // Check if all price fields are valid (greater than 0)
          const requiredFields = ['unit_selling_price',  'invoice_amount'];
          const isValid = requiredFields.every((field) => row[field] > 0);
          const invalidFields = requiredFields.filter((field) => row[field] <= 0);
          console.log("Invalid fields:", invalidFields);

          if (!isValid) {
            invalidFields.forEach(field => {
                console.log(`Invalid field: ${field}, value:`, row[field]);
            });
            toast.error('All price fields must be greater than 0');
            return;  // Don't proceed if the validation fails
          }
      
          try {
            // Send updated row data to the backend
            const response = await apiService("actual-sales/update-record", "POST", row);
            if (response.data.success) {
              setFilteredData(newData); // Update the frontend data state
              setEditingKey(null); // Exit edit mode
              toast.success("Record updated successfully!");
            } else {
              toast.error("Failed to update record.");
            }
          } catch (error) {
            console.error("Error updating record:", error);
            toast.error("Failed to update record.");
          }
        }
      };
      

    // Dynamically generate the columns array
    const columns = [
        ...dynamicColumns,
        // {
        //     title: "Action",
        //     dataIndex: "action",
        //     render: (_, record) => (
        //         <span>
        //             {editingKey === record.id ? (
        //                 <span>
        //                     <Button onClick={() => saveRow(record.id)} style={{ marginRight: 8 }}>
        //                         Save
        //                     </Button>
        //                     <Button color="danger" onClick={cancelEditing}>Cancel</Button>
        //                 </span>
        //             ) : (
        //                 <span>
        //                     <EditOutlined
        //                         onClick={() => startEditing(record.id)}
        //                         style={{ marginRight: 8, cursor: "pointer" }}
        //                     />
        //                     <DeleteOutlined
        //                         onClick={() => deleteRow(record.id)}
        //                         style={{ cursor: "pointer" }}
        //                     />
        //                 </span>
        //             )}
        //         </span>
        //     ),
        // },
    ];
    const handleExport = async () => {
        try {
            const payload = {};
            if (dates && dates.length === 2 && dates[0] && dates[1]) {
                const [startDate, endDate] = dates.map((date) => date.format("YYYY-MM-DD"));
                payload.startDate = startDate;
                payload.endDate = endDate;
            }
              payload.record_type = 'actual_sales_summary';
            const response = await apiService("actual-sales/get-all-records", "POST", payload);
            const allData = normalizeSummaryRecords(getSummaryRecords(response));

            if (!allData || allData.length === 0) {
                alert("No data available to export.");
                return;
            }

           const excelHeaders = [
                            "Customer", "Criteria", "Model","Item Type", "Part Number", "Invoice Month",  "Unit Selling Price", "Qty Inv", "Inv Amt",
                        ];

const keyMap = [
   "customer_name",
   "criteria",
   "model",   
   "item_type", 
   "part_number",        // Item No        // Item Type 
   "invoice_month_year",       // Inv Date
   "unit_selling_price", // Sell Price
    "total_quantity",  // Qty Inv
    "total_invoice_amount",     // Inv Amt
 
];

            // Prepare data for export (convert number columns to numbers)
const numberCols = [
    "Unit Selling Price", "Qty Inv", "Inv Amt"
];
const numberColIndexes = numberCols.map(header => excelHeaders.indexOf(header));

// Prepare data for export, converting number columns to numbers
const exportData = allData.map(row =>
    keyMap.map((key, idx) => {
        let value = row[key] !== undefined ? row[key] : "";
        if (numberColIndexes.includes(idx)) {
            // Remove commas before converting to number
            const num = Number(String(value).replace(/,/g, ""));
            return value !== undefined && value !== null && value !== "" && !isNaN(num) ? num : "";
        }
        return value !== undefined && value !== null ? value : "";
    })
);

// Convert to worksheet with custom headers
const worksheet = XLSX.utils.aoa_to_sheet([excelHeaders, ...exportData]);

// Set cell type to number for these columns
numberColIndexes.forEach(colIdx => {
    exportData.forEach((row, rowIdx) => {
        const cellRef = XLSX.utils.encode_cell({ c: colIdx, r: rowIdx + 1 }); // +1 for header row
        const value = row[colIdx];
        if (worksheet[cellRef] && typeof value === "number" && !isNaN(value)) {
            worksheet[cellRef].t = "n";
            worksheet[cellRef].z = "#,##0.00"; // Optional: Excel number format
        }
    });
});

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Actual Sales");
            XLSX.writeFile(workbook, "ActualSalesSummaryData.xlsx");
            toast.success("Data exported successfully!");
        } catch (error) {
            console.error("Error exporting data:", error);
            alert("Failed to export data. Please try again.");
        }
    };
    return (
        <div className="bg-white p-4">
            <div className="flex items-center space-x-4 mb-4">
                <div className="md:w-1/4 w-full flex flex-col">
                    <label className="mb-2 text-[#000] font-bold">Date Range</label>
                    <RangePicker
                        format="DD/MM/YYYY"
                        onChange={handleDateRangeChange}
                        className="border border-gray-300 p-5 rounded-md w-full"
                        value={dates}
                        size="large"
                    />
                </div>
                <div className="md:w-1/4 w-full flex items-center mt-6">
                    <label className="mb-2 block text-sm  invisible ">
                        Search
                    </label>
                    <button className="bg-[#3D3D3D] w-full h-10 rounded-md cursor-pointer"  onClick={handleSearch}>
                        <span className="text-white" >Search</span>
                    </button>
                </div>
            </div>
            <div className="ml-auto flex gap-x-5 justify-end py-1 mb-2"  >
                {/* Import Button with icon */}
                {/* <button className="bg-[#287DD1] text-white px-6 py-3 rounded-md flex items-center gap-x-2 cursor-pointer" onClick={() => navigate("/upload-actual-excel")}>
                    <FaUpload className="text-white" /> 
                    <span className="text-white">Import</span>
                </button> */}

                {/* Export Button with icon */}
                <button className="bg-[#107C41] text-white px-6 py-3 rounded-md flex items-center gap-x-2  cursor-pointer" onClick={handleExport}>
                    <FaDownload className="text-white" />
                    <span className="text-white">Export</span>
                </button>
            </div>
            {/* Table Section */}
            {loading ? (
                <div>
                    {/* <Spinner /> */}
                </div>) : filteredData.length === 0 ? (
                    <div className="text-center text-gray-500 py-4">
                        No Records Found
                    </div>
                ): (<div className="overflow-x-auto bg-white shadow-md">
                    <table className="min-w-full text-sm border border-[#D5D5D5]">
                        <thead className="bg-[#F5F7FF] sticky top-0 z-10">
                            <tr>
                                {columns.map((col) => (
                                    <th
                                        key={col.dataIndex}
                                        className="px-4 py-2 font-semibold whitespace-nowrap text-left"
                                    >
                                        {col.title}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody >
                            {filteredData.map((row) => (

                                <tr
                                    key={row.id}
                                    className="border-b hover:bg-[#F5F7FF] border-b border-[#D5D5D5]"
                                >
                                    {columns.map((col) => {
                                        if (col.dataIndex === "customer_name" && row.customerRowSpan === 0) {
                                            return null;
                                        }
                                        if (col.dataIndex === "criteria" && row.criteriaRowSpan === 0) {
                                            return null;
                                        }

                                        return (
                                            <td
                                                key={col.dataIndex}
                                                rowSpan={
                                                    col.dataIndex === "customer_name"
                                                        ? row.customerRowSpan
                                                        : col.dataIndex === "criteria"
                                                            ? row.criteriaRowSpan
                                                            : undefined
                                                }
                                                className={`px-4 py-2 text-black align-top border-r border-[#D5D5D5]
                                                    ${col.dataIndex === "part_number" 
                                                    ? "max-w-[250px] whitespace-normal break-words" 
                                                    : "whitespace-nowrap"}
                                                    ${col.dataIndex === "customer_name" || col.dataIndex === "criteria" ? "font-semibold bg-[#FAFAFA]" : ""}`}
                                            >
                                                {col.dataIndex === "action" ? (
                                                    col.render(undefined, row) // Pass undefined for unused first parameter
                                                ) : (
                                                    <EditableCell
                                                        record={row}
                                                        columnKey={col.dataIndex}
                                                    />
                                                )}
                                                
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>)
            }
            {total > 10 && (
         <div className="mt-4 flex justify-end">
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={total}
                    onChange={handlePageChange}
                    showSizeChanger
                    pageSizeOptions={['100', '500', '1000']}
                />
            </div>
)}
        </div>
    );
};

export default ActualSalesSummary;
